import { render, staticRenderFns } from "./navSection.vue?vue&type=template&id=684b44fb&scoped=true&"
import script from "./navSection.vue?vue&type=script&lang=js&"
export * from "./navSection.vue?vue&type=script&lang=js&"
import style0 from "./navSection.vue?vue&type=style&index=0&id=684b44fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684b44fb",
  null
  
)

export default component.exports